export const ACCESS_TOKEN_KEY = 'foodies.accessToken';
export const REFRESH_TOKEN_KEY = 'foodies.refreshToken';